import logger from "@/lib/logger";
export default function debugLog() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  logger.debug("[debug]", ...args);
}